import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration.js";
import { Catalog, pageLoader } from "catalog";
import "typeface-montserrat";
import "typeface-lato";
import Logo from "./static/assets/img/logo/logo.svg";
import Styles from "./styles.css";

const theme = {
  // Colors
  background: "#FFFFFF",
  textColor: "#333333",
  codeColor: "#00263E",
  linkColor: "#04bb00",

  // Used in PageHeader
  pageHeadingBackground: "#303030",
  pageHeadingTextColor: "#fff",

  // NavigationBar background color, but also sometimes used as a foreground
  // or border color.
  lightColor: "#D6D6D6",

  // Used for navigation bar
  navBarBackground: "#F2F2F2",
  navBarTextColor: "#303030",

  // Used in ResponsiveTabs (tab text), Download specimen (title text).
  // Typography: headings.
  brandColor: "#303030",

  sidebarColor: "#FCFCFC",
  sidebarColorActive: "#04bb00",
  sidebarColorText: "#303030",
  sidebarColorTextActive: "#04bb00",
  sidebarColorLine: "#EBEBEB",
  sidebarColorHeading: "#303030",

  // Fonts
  fontHeading: "'Montserrat', sans-serif",
  fontFamily: "'Lato', sans-serif",
};

const pages = [
  {
    path: "/",
    title: "Hi! 👋🏼",
    hideFromMenu: true,
    content: pageLoader(() => import("./pages/START.md")),
  },
  {
    title: "LOGO",
    pages: [
      {
        path: "logo/transparent",
        title: "Transparent",
        content: pageLoader(() => import("./pages/logo/TRANSPARENT.md")),
      },
      {
        path: "logo/light",
        title: "Light",
        content: pageLoader(() => import("./pages/logo/LIGHT.md")),
      },
      {
        path: "logo/dark",
        title: "Dark",
        content: pageLoader(() => import("./pages/logo/DARK.md")),
      },
    ],
  },
  {
    title: "TYPOGRAPHY",
    pages: [
      {
        path: "typography/general",
        title: "General",
        content: pageLoader(() => import("./pages/typography/GENERAL.md")),
      },
      {
        path: "typography/montserrat",
        title: "Montserrat",
        content: pageLoader(() => import("./pages/typography/MONTSERRAT.md")),
      },
      {
        path: "typography/lato",
        title: "Lato",
        content: pageLoader(() => import("./pages/typography/LATO.md")),
      },
    ],
  },
  {
    title: "COLORS",
    pages: [
      {
        path: "colors/main-colors",
        title: "Main Colors",
        content: pageLoader(() => import("./pages/colors/MAINCOLORS.md")),
      },
      {
        path: "colors/color-palettes",
        title: "Color Palettes",
        content: pageLoader(() => import("./pages/colors/COLORPALETTES.md")),
      },
    ],
  },
];

ReactDOM.render(
  <Catalog
    title="NE Design - Styleguide"
    logoSrc={Logo}
    pages={pages}
    theme={theme}
    styles={Styles}
  />,
  document.getElementById("catalog")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();



// WEBPACK FOOTER //
// ./catalog/index.js